/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, computed, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { LINE_ISOLATION_INSTANCE_TOKEN } from '@app/components/isolation/line-isolation-instance.token';
import { IsolationInstanceData } from '@app/types/LineIsolation';
import { FlexiblePanelComponent } from '@core/ui/flexible-panel/flexible-panel.component';
import { MapConfigService } from '@map/services/map-config.service';
import { LineIsolationListOverlayRef } from './line-isolation-list-overlay-ref';
import { LineIsolationService } from './line-isolation.service';

@Component({
    selector: 'dash-gis-isolation-list',
    templateUrl: './line-isolation-list.component.html',
    styleUrls: [ './line-isolation-list.component.scss' ],
    imports: [ FlexiblePanelComponent, MatButton ],
    standalone: true
})
export class LineIsolationListComponent {
    selectedLines = computed(
        () => this.lineIsolationService.hasIsolationData()
            ? this.lineIsolationService.isolationData().selectedLines
            : []
    );
    isolatedNodes = computed(
        () => this.lineIsolationService.hasIsolationData()
            ? this.lineIsolationService.isolationData().nodes
            : []
    );
    isolatedLines = computed(
        () => this.lineIsolationService.hasIsolationData()
            ? this.lineIsolationService.isolationData().lines
            : []
    );
    isolatedParcels = computed(
        () => this.lineIsolationService.hasIsolationData()
            ? this.lineIsolationService.isolationData().parcels
            : []
    );
    parcelsIncluded: boolean;

    constructor(
        private lineIsolationService: LineIsolationService,
        @Inject(LineIsolationListOverlayRef) private overlayRef: LineIsolationListOverlayRef,
        @Inject(LINE_ISOLATION_INSTANCE_TOKEN) private instance: IsolationInstanceData
    ) {
        this.parcelsIncluded = !!this.lineIsolationService.isolationLayers[instance.mapName][instance.layerName]?.parcelLayer
    }

    public close() {
        this.overlayRef.close();
    }

    public selectFeatures() {
        this.lineIsolationService.selectFeatures().subscribe(() => {
            this.close();
        });
    }
}
